/**
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 **/
import React from 'react';
import { useLookAndFeel } from '@userzoomplatform/pe-study-tasks/dist/lib';
import styled from 'styled-components';
import AccessAgreementPage, { Props } from './access-agreement-page';
import AccessAgreementPageStyles from './access-agreement-page-styles';

const AccessAgreementWithLookAndFeel = (props: Props) => {
	const { styles } = useLookAndFeel();
	// eslint-disable-next-line react/jsx-props-no-spreading
	return <AccessAgreementPage {...props} lookAndFeel={styles.lookAndFeel} />;
};

export default styled(AccessAgreementWithLookAndFeel)`
	${AccessAgreementPageStyles}
`;
